export default __webpack_public_path__ + "static/media/ngo.32d4cb8d.png";